import { createTheme } from "@mui/material/styles";
import { sharedSxTextField, sharedSxFormControl } from "./sharedStyles";

// import '../../fonts/NunitoSans-Regular.ttf';
// import '../../fonts/NunitoSans-Black.ttf';

const customizedTheme = createTheme({
  palette: {
    dataGrid: {
      headerBackgroundColor: "#999999",
      headerFontColor: "#000000",
      rowOddBackgroundColor: "#D5D5D5",
    },
    primary: {
      light: "#6054c4",
      main: "#392AB6",
      dark: "#271d7f",
      contrastText: "#ffffff",
    },
    chip: {
      main: "#21CCFB",
      contrastText: "#ffffff",
    },
    avalonBlueButton: {
      main: "#392AB6",
      contrastText: "#ffffff",
    },
    primaryButton: {
      main: "#21CCFB",
      bodytext: "#FFFFFF",
    },
    selectedChip: {
      main: "#392AB6",
      contrastText: "#ffffff",
    },
    useCaseComplete: {
      main: "#004d40",
      contrastText: "#ffffff",
    },
    button2025RebrandPrimary: {
      main: "#7745FF",
      contrastText: "#ffffff",
    },
    button2025RebrandSecondary: {
      main: "#7A7FA7",
      contrastText: "#ffffff",
    },
    button2025RebrandText: {
      main: "#912FC3",
      contrastText: "#ffffff",
    },
    warningIcon: {
      main: "#A86200",
    },
  },
  typography: {
    fontFamily: "Nunito Sans, sans-serif",
    fontStyle: "normal",
    h1: {
      fontFamily: "Nunito Sans, sans-serif",
      fontWeight: "bold",
    },
    h2: {
      fontFamily: "Nunito Sans, sans-serif",
      fontWeight: "bold",
    },
    h3: {
      fontFamily: "Nunito Sans, sans-serif",
      fontWeight: "bold",
    },
    h4: {
      fontFamily: "Nunito Sans, sans-serif",
      fontWeight: "bold",
    },
    bodytext: {
      fontFamily: "Nunito Sans, sans-serif",
    },
    smalltext: {
      fontFamily: "Nunito Sans, sans-serif",
    },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        size: "small",
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          ".MuiAccordionSummary-content.Mui-expanded": {
            marginTop: "0px",
            marginBottom: "0px",
          },
        },
      },
    },
    MuiFormControl: {
      defaultProps: {
        size: "small",
      },
    },
    MuiCssBaseline: {
      styleOverrides: `
        
          `,
    },
  },
});

export default customizedTheme;
